<template>
  <div class="content">
    <div class="content-top">
      <div class="content-top-item">
        <div><img src="../../../assets/image/foundation/monitor.png"></div>
        <div>
          <p style="font-size: 40px;color: #000">{{count.sum}}</p>
          <p style="font-size: 18px;color: #999">设备总数</p>
        </div>
      </div>
      <div class="content-top-item">
        <div><img src="../../../assets/image/foundation/on-line.png"></div>
        <div>
          <p style="font-size: 40px;color: #000">{{count.online}}</p>
          <p style="font-size: 18px;color: #999">在线设备</p>
        </div>
      </div>
      <div class="content-top-item">
        <div><img src="../../../assets/image/foundation/off-line.png"></div>
        <div>
          <p style="font-size: 40px;color: #000">{{count.offline}}</p>
          <p style="font-size: 18px;color: #999">离线设备</p>
        </div>
      </div>
      <div class="content-top-item">
        <div><img src="../../../assets/image/foundation/jiankong.png"></div>
        <div>
          <p style="font-size: 40px;color: #000">{{count.caramer}}</p>
          <p style="font-size: 18px;color: #999">升降机监控</p>
        </div>
      </div>
      <div class="content-top-item">
        <div><img src="../../../assets/image/foundation/alarm.png"></div>
        <div>
          <p style="font-size: 40px;color: #000">{{count.warring}}</p>
          <p style="font-size: 18px;color: #999">报警设备</p>
        </div>
      </div>
    </div>
    <div class="equipment-list">
      <div class="top">
        <div class="top-left">
          <span style="color: #666;margin-right: 3vw;font-size: 16px">升降机设备列表</span>
          <span style="color: #666;font-size: 16px"><span class="circle" style="background: #10B33B"></span>在线</span>
          <span style="margin: 0 2vw;font-size: 16px"><span class="circle" style="background: #999999"></span>离线</span>
          <span style="font-size: 16px"><span class="circle" style="background: #D81E06"></span>报警</span>
        </div>
        <el-button size="small" @click="addEquipmentDialog = true" class="button-add">添加</el-button>
      </div>
      <div class="equipment-item">
        <div v-for="item in elevatorList" :key="item.id" :style="{ background: item.status == 0? '#D8D8D8' : (item.status == 1? '#DBE2EF' : item.status == 2? '#F7A69B' : '')}" style="height: 200px;padding: 18px 0;">
          <p style="font-size: 20px;">
            <span v-if="item.status == 0" class="big-circle" style="background: #999999;"></span>
            <span v-else-if="item.status == 1" class="big-circle" style="background: #10B33B;"></span>
            <span v-else-if="item.status == 2" class="big-circle" style="background: #D81E06;"></span>
            {{item.name}}</p>
          <div style="width: 70%;margin: 2vh auto;display: flex;justify-content: space-between;">
            <div style="display: flex;flex-direction: column;align-items: center;justify-content: space-between;height: 7vh;">
              <p style="font-size: 18px">当前载重</p>
              <p style="font-size: 18px">{{item.weight || 0}}T</p>
            </div>
            <div style="display: flex;flex-direction: column;align-items: center;justify-content: space-between;height: 7vh;">
              <p style="font-size: 18px">运行状态</p>
              <p style="font-size: 18px">
                <span v-if="item.status == 0">{{item.statusStr}}</span>
                <span v-else-if="item.status == 1">{{item.statusStr}}</span>
                <span v-else-if="item.status == 2" style="color: #D81E06;">{{item.statusStr}}</span>
              </p>
            </div>
          </div>
          <p>
            <span class="button" style="margin-right: 2vw" @click="openDetail(item.deviceId)">设备详情</span>
            <span class="button" @click="toRecord(item.id, item.deviceId)">监测记录</span>
          </p>
        </div>
      </div>
    </div>
    <!-- 添加设备弹出框 -->
    <el-dialog
      :visible.sync="addEquipmentDialog"
      center
      width="650px">
      <p slot="title" style="padding: 11px 24px;font-size: 16px;text-align: left;background:#ECF0F5;">设备添加</p>
      <el-form :model="addForm" :rules="rules" ref="ruleForm" label-width="180px">
        <el-form-item label="设备名称：" prop="name">
          <el-input v-model="addForm.name" placeholder="请输入设备名称"></el-input>
        </el-form-item>
        <el-form-item label="设备编号：" prop="deviceId">
          <el-input v-model="addForm.deviceId" placeholder="请输入设备编号"></el-input>
        </el-form-item>
        <el-form-item label="型号规格：" prop="deviceSpecification">
          <el-input v-model="addForm.deviceSpecification" placeholder="请输入型号规格"></el-input>
        </el-form-item>
        <el-form-item label="设备厂家：" prop="machType">
          <el-select v-model="addForm.machType" placeholder="请选择设备厂家">
            <el-option v-for="item in crane" :key="item.val" :label="item.perName" :value="item.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安装单位：" prop="installUnit">
          <el-input v-model="addForm.installUnit" placeholder="请输入安装单位"></el-input>
        </el-form-item>
        <el-form-item label="人脸识别编号：" prop="attendanceSn">
          <el-select v-model="addForm.attendanceSn" placeholder="请选择人脸识别单位">
            <el-option v-for="item in groups" :key="item.id" :label="item.imei" :value="item.imei"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="班组：" prop="teamsId">
          <el-select v-model="addForm.teamsId" placeholder="请选择班组">
            <el-option  v-for="item in teams" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="addEquipmentDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm('ruleForm')" style="background: #4D6EB1">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 设备详情弹出框 -->
    <el-dialog
      :visible.sync="equipmentDetailDialog"
      center
      width="450px">
      <p slot="title" style="padding: 11px 24px;font-size: 18px;text-align: left;background:#ECF0F5;">设备详情</p>
      <el-form label-width="160px">
        <el-form-item label="设备名称：">{{currentInfo.name}}</el-form-item>
        <el-form-item label="设备编号：">{{currentInfo.deviceId}}</el-form-item>
        <el-form-item label="型号规格：">{{currentInfo.name}}</el-form-item>
        <el-form-item label="设备厂家：">{{currentInfo.machType}}</el-form-item>
        <el-form-item label="安装单位：">{{currentInfo.name}}</el-form-item>
        <el-form-item label="人脸识别编号：">{{currentInfo.attendanceSn}}</el-form-item>
        <el-form-item label="班组：">{{currentInfo.teamsName}}</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="equipmentDetailDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  import base from '../../../untils/base'
  export default {
    data() {
      return {
        addEquipmentDialog: false,    // 添加设备弹出框
        equipmentDetailDialog: false,    // 设备详情弹出框
        projectId: util.session.get('groupId'),
        elevatorList: [],       //  升降机列表
        towerId: '',
        deviceId: '',
        addForm: {},  
        count: {},   // 升降机数量
        rules: {
          name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
          machType: [ { required: true, message: '请选择厂家名称', trigger: 'blur' }],
          deviceId: [{ required: true, message: '请输入设备编号', trigger: 'blur' }],
          attendanceSn: [ {  message: '请选择人脸识别编号', trigger: 'blur' }],
          teamsId: [ {  message: '请选择班组', trigger: 'blur' }],  
          installUnit: [ { required: true, message: '请输入安装单位', trigger: 'blur' }],   
          deviceSpecification: [ { required: true, message: '请输入型号规格', trigger: 'blur' }],
        },
        crane: [
            // { val: '1', perName: '海智智连' },
            // { val: '2', perName: '瞳声智连' },
            // { val: '3', perName: '帧码智连' },
            { perName: '海智智连', val: '1' },
            { perName: '瞳声智连', val: '2' },
            { perName: '帧码物联', val: '3' },
            { perName: '帧码智连', val: '4' },
        ],
        groups: [],
        teams: [],
        currentInfo: {},    // 点击查看设备详情
            
      }
    },
    created() {
      this.getList()
      this.getNumber()
      this.getTeams()
      this.getElevatorNumber()
    },
    mounted() {
     
    },
    methods: {
      //获取升降机数量
      getElevatorNumber(){
        myHttp.getCountByProjectId({
          projectId: this.projectId
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            this.count = resp.data.data
          }
        })
      },

      //获取设备
      getList(){
        myHttp.getEleListByPage({
            projectId:this.projectId
        }).then(resp => {
          console.log(resp);
            if(resp.data.code=='200'){
                const list = resp.data.data.elevatorList||[]
                //  status 0 离线   1 在线   2 报警
                for(let i=0;i<list.length;i++){
                  if(new Date().getTime() - new Date(list[i].updateDate).getTime() > 900000 || new Date().getTime() - new Date(list[i].updateDate).getTime() < 0){
                    list[i].status = 0
                    list[i].statusStr = '离线'
                  }else{
                    if(list[i].systemStatusHeight == 2 || list[i].systemStatusNum == 2 || list[i].systemStatusSpeed == 2 || list[i].systemStatusTilt == 2 || list[i].systemStatusWeight == 2){
                      list[i].status = 2
                      list[i].statusStr = '报警'
                    }else{
                      list[i].status = 1
                      list[i].statusStr = '在线'
                    }
                  }
              }
              this.elevatorList = list
              if(list.length>0 && this.towerId==''){
                  this.towerId = list[0].id
                  this.deviceId = list[0].deviceId
              }
            }
        })
      },
      // 获取人脸识别编号
      getNumber() {
      let that = this
      myHttp.getRecogByProjectId({
          projectId: util.session.get('groupId')
      }).then(
          function(resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.pageInfo || []
              that.groups = list
            } else {
              that.$message.error(resp.data.msg)
              that.dataText = '暂无数据'
            }
          }
        )
    },
    // 获取班组
    getTeams() {
      let that = this
      myHttp.getTeamsListtz({
        projectId: util.session.get('groupId')
      }).then(function(resp) {
          if (resp.data.code == '200') {
            that.teams = resp.data.data.teamsList || []
          } else {
            that.$message.error(resp.data.msg)
          }
        }
      )
    },

    // 增加
    submitForm(formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.addForm.projectId = that.projectId
           myHttp.createInfoElevator(that.addForm).then( function(resp) {
              if (resp.data.code == '200') {
                that.$message.success('添加成功')
                that.addEquipmentDialog = false
                that.addForm = {}
                that.getList()
              } else {
                that.$message.error(resp.data.msg)
              }
            }
          )
        } else {
          return false;
        }
      });
    },


      //  打开设备详情
      openDetail(deviceId){
        for(let i =0; i<this.elevatorList.length; i++){
          if(deviceId == this.elevatorList[i].deviceId){
            this.currentInfo = this.elevatorList[i]
          }
        }
        this.equipmentDetailDialog = true
      },

      // 去监测记录
      toRecord(id, deviceId){
        this.$router.push({
          path: '/elevatorRecord',
          query: {
            id: id,
            deviceId: deviceId
          }
        })
      }
    },
  }
</script>

<style scoped>
.content-top{
  border-radius: 6px;
  /* background: #FFFFFF; */
  /* box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3); */
  /* padding: 10px; */
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 2vh;
}
.content-top-item{
  display: flex;
  width: 19.5%;
  height: 150px;
  align-items: center;
  justify-content: space-between;
  padding: 1.5vh 2vw;
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.equipment-list{
  border-radius: 6px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.top{
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #E7E7E7;
}
.button-add:hover{
  background-color: #4D6EB1;
  color: #fff;
}
.circle{
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 20px;
  margin-right: 8px;
}
.big-circle{
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 20px;
  margin-right: 8px;
}
.equipment-item{
  display: flex;
  flex-wrap: wrap;
  height: 64vh;
  background-color: #fff;
  padding: 1vh 2vw;
  padding-right: 0;
  overflow: auto;
}
.equipment-item > div{
  width: 22%;
  height: 18vh;;
  padding: 1vh 0;
  margin-right: 2vw;
  margin-bottom: 1vw;
  border-radius: 6px;
  background: #DBE2EF;
  box-shadow: 4px 4px 12px 0px rgba(77, 110, 177, 0.3);
}
.el-pagination{
  border-radius:  0 0 6px 6px;
  box-shadow: 6px 0px 10px 0px rgba(197, 197, 197, 0.3);
}
.button{
  width: 80px;
  height: 34px;
  border-radius: 6px;
  padding: 4px;
  background: #FDFEFE;
  box-sizing: border-box;
  border: 1px solid rgba(153, 153, 153, 0.8);
  font-size: 16px;
  cursor: pointer;
}

.content >>> .el-icon-close:before{
  /* content: ''; */
  color: #9E9E9E;
  font-size: 18px;
  position: relative;
  top: -4px;
}
.content >>> .el-dialog__header{
  padding: 0;
}
.content >>> .el-dialog{
  border-radius: 6px;
}
.dialog-title{
  height: 48px;
  background: #ECF0F5;
  font-size: 16px;
  color: #666;
  border-radius: 6px 6px 0px 0px;
  line-height: 48px;
}
.el-input{
  width: 300px;
}
.el-select{
  width: 300px;
}
</style>